import React, { useState, useEffect } from 'react';
import { Collection, Preview } from './modules';

function App({ config }) {
  const [ assets ] = useState(config.assets);
  const [ type ] = useState(config.type);
  const [ selected, setSelected ] = useState(null);

  useEffect(() => {
    if(type == "asset"){
      setSelected(assets[0]);
    }
  }, [ type ]);

  const back = () => setSelected(null);
  const setNext = currentIndex => setSelected(assets[currentIndex - 1]);
  const setPrev = currentIndex => setSelected(assets[currentIndex + 1]);

  const selectedIndex = assets.indexOf(selected);
  const nav = {
    onPrev:
      selectedIndex >= 0 && selectedIndex === 0
        ? undefined
        : () => setNext(selectedIndex),
    onNext:
      selectedIndex >= 0 && selectedIndex === assets.length - 1
        ? undefined
        : () => setPrev(selectedIndex),
  };

  return selected ? <Preview fullScreen={type === "asset"} asset={selected} onBack={back} preventBack={type !== "asset"} showMetadata={type !== "asset"} {...nav}/> : <Collection assets={assets} onSelect={item => setSelected(item)} />
}

export default App;
